import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Add / edit a group (v2 root model). The single "amount" input maps to the
// correct field on save: `credit` for a Credit-Renew group, `subsidy` for a
// Subsidy group — this is what the cloud v2 subsidy resolution actually reads
// (friggAppV2Controller / orderController read group.subsidy for subsidyGroup).
// groupId is immutable on edit (it keys memberships + the renewal task).
@Component({
  selector: 'v2-group-dialog',
  templateUrl: './group-dialog.component.html',
  styleUrls: ['./dialog-shared.css']
})
export class GroupDialogComponent {
  model: any;

  constructor(
    public ref: MatDialogRef<GroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const g = data.group || {};
    const isSubsidy = g.worker === 'subsidyGroup';
    this.model = {
      name: g.name || '',
      groupId: g.groupId || '',
      worker: g.worker || 'creditRenew',
      amount: Number(isSubsidy ? g.subsidy : g.credit) || 0,
      accumulate: g.accumulate === true,
      creditLimit: Number(g.creditLimit) || 0,
      customerId: g.customerId || '',
      customerReference: g.customerReference || '',
      systemIds: Array.isArray(g.systemIds) ? g.systemIds.slice() : [],
      setHour: g.setHour !== undefined ? g.setHour : 0,
      setMinutes: g.setMinutes !== undefined ? g.setMinutes : 0,
      renewalMonthly: true,   // credit renewal is always monthly
      isTest: false
    };
  }

  isSubsidy() { return this.model.worker === 'subsidyGroup'; }

  toggleSystem(systemId: string) {
    const i = this.model.systemIds.indexOf(systemId);
    if (i === -1) { this.model.systemIds.push(systemId); } else { this.model.systemIds.splice(i, 1); }
  }
  hasSystem(systemId: string) { return this.model.systemIds.indexOf(systemId) !== -1; }

  // Build the persisted shape: correct subsidy/credit field for the worker,
  // and only carry renewal fields for a Credit-Renew group.
  private buildPayload() {
    const p: any = {
      name: this.model.name,
      worker: this.model.worker,
      customerId: this.model.customerId || null,
      // Set → this group's purchases get an invoice of their own carrying this
      // reference (billing.component.ts buildInvoices).
      customerReference: String(this.model.customerReference || '').trim(),
      systemIds: this.model.systemIds
    };
    if (this.isSubsidy()) {
      p.subsidy = Number(this.model.amount) || 0;
      p.credit = 0;
    } else {
      p.credit = Number(this.model.amount) || 0;
      p.subsidy = 0;
      p.accumulate = this.model.accumulate === true;
      p.creditLimit = Number(this.model.creditLimit) || 0;
      p.setHour = this.model.setHour;
      p.setMinutes = this.model.setMinutes;
      p.renewalMonthly = true;   // credit renewal is always monthly
    }
    return p;
  }

  save() {
    if (this.data.mode === 'add') {
      if (!this.model.name || !this.model.groupId) { return; }
      const payload = { ...this.buildPayload(), groupId: this.model.groupId };
      this.ref.close({ action: 'add', isTest: this.model.isTest === true, payload });
    } else {
      // groupId omitted on edit — it must not change.
      this.ref.close({ action: 'edit', patch: this.buildPayload() });
    }
  }
}
